<template>
	<div class="body">
		<div class="body-container" v-if="targetData">

			<div class="title-ch">{{targetData.title}}</div>

			<el-table :data="targetData.list" border stripe>
				<el-table-column label="年份" align="center" prop="year" />
				<el-table-column label="总生产产值(亿元)" align="center" prop="amount" />
				<el-table-column label="一产生产产值(亿元)" align="center" prop="first" >
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.id, row.year, 'first', '一产生产产值', row.first)">{{row.first}}</label>
					</template>
				</el-table-column>
				<el-table-column label="二产生产产值(亿元)" align="center" prop="second" >
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.id, row.year, 'second', '二产生产产值', row.second)">{{row.second}}</label>
					</template>
				</el-table-column>
				<el-table-column label="三产生产产值(亿元)" align="center" prop="third" >
					<template v-slot="{ row }">
						<label class="edit-label" @click="clickChangeData(row.id, row.year, 'third', '三产生产产值', row.third)">{{row.third}}</label>
					</template>		
				</el-table-column>
			</el-table>
			<div class="source-note">注：表数据来源于统计年鉴，<label style="color: red;">如有错误，可点击修正</label>。</div>
		</div>

		<div class="action-ctr">
			<el-button type="primary" icon="el-icon-right" size='medium' @click="clickNext()"
				class="next-btn">下一步</el-button>
		</div>

		<el-dialog title="原理介绍" :visible.sync="showIntroDialog" append-to-body v-if="showIntroDialog" align="center">

			<div class="rich-ctr">
				<div class="rich-value" v-html="introDialog.value"></div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseIntroDialog()">确 定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog :title="dataTitle" :visible.sync="showDataDialog" append-to-body v-if="showDataDialog"
			align="center">
			
			<div class="data-ctr">
				<el-input v-model="dataValue" placeholder="请输入数值" class="data-input" />
			</div>
		
			
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickConfirmData()">确 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getMisGdpData,
		updateMisData
	} from "@/api/service"

	import {
		getSpanMap,
		isEmpty
	} from "@/utils/util"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Famous",
		data() {
			return {
				params: {
					page: 1,
					pageSize: 20
				},
				data: null,
				showIntroDialog: false,
				introDialog: null,
				targetData: null,
				sourceData: null,
				cagrRateData: null,
				ftRateData: null,
				cagrData: null,
				ftData: null,
				showDataDialog: false,
				dataTitle: '',
				dataValue: ''
			}
		},
		created() {
			this.initPageData();
		},

		methods: {
			initPageData() {
				this.params['id'] = this.$route.query.id;
				this.requestData();
			},

			buildParams() {
				this.params['rowId'] = this.rowId;
				this.params['field'] = this.field;
				this.params['type'] = 'gdp';
				this.params['value'] = this.dataValue;
				return this.params;
			},

			requestData() {
				getMisGdpData(this.buildParams()).then(res => {
					let realData = res.data;
					this.targetData = realData;
	
				});
			},

			clickNext() {
				let path = '/mis_job?id=' + this.params['id']
				this.$router.push(path);
			},

			clickRule(route) {
				if (route.type == this.variableType.File) {
					let path = route.path;
					window.open(path, '_blank')
				} else if (route.type == this.variableType.Rich) {
					this.showIntroDialog = true;
					this.introDialog = route;
				}
			},
			
			clickChangeData(id, year, field, name, value){
				let title = year + '年' + name;
				
				title += '数据修改';
				
				this.rowId = id;
				this.year = year;
				this.field = field;
				this.dataTitle = title;
				this.dataValue = value;
				this.showDataDialog = true;
			},

			clickCloseIntroDialog() {
				this.showIntroDialog = false;
			},
			
			clickConfirmData(){
				updateMisData(this.buildParams()).then(res => {
					this.requestData();
					this.showDataDialog = false;
				})
			}

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "mis_gdp.scss";
</style>